import $ from 'jquery';

$( () => {
  let dialog = $( 'dialog' );

  if ( dialog.length ) {
    $('.open-dialog').on( 'click', ( e ) => {

      $('body').addClass('no-scroll');

      const dialogId = $( e.currentTarget ).attr( 'data-dialog-id' );
      let targetDialog = $('#' + dialogId);

      if (targetDialog) {
        targetDialog.get(0).showModal();
        targetDialog.css({ opacity: 0 }).animate({ opacity: 1 }, 300);
      }
    });

    $('.close-dialog').on( 'click', ( e ) => {
      $( 'body' ).removeClass( 'no-scroll' );
        let targetDialog = $( e.currentTarget ).closest('dialog');

        targetDialog.animate({ opacity: 0 }, 300, function () {
          targetDialog.get(0).close(); 
        });

    });

    $( 'dialog' ).on( 'click', ( e ) => {
        if ( e.target === e.currentTarget ) {
          $( 'body' ).removeClass( 'no-scroll' );
          e.currentTarget.close();
        }
    });  


    const params = new URLSearchParams(window.location.search);

    if (params.get('submitted') === 'true') {
      // Change this to the actual ID of the dialog you want to open
      const targetDialog = $('#floorplan-signup');

      if (targetDialog.length) {
        $('body').addClass('no-scroll');
        targetDialog.get(0).showModal();
        targetDialog.css({ opacity: 0 }).animate({ opacity: 1 }, 300);
      }
    }

    if (params.get('floorplan-dialog') === 'true') {
      // Change this to the actual ID of the dialog you want to open
      const targetDialog = $('#floorplan-signup');

      if (targetDialog.length) {
        $('body').addClass('no-scroll');
        targetDialog.get(0).showModal();
        targetDialog.css({ opacity: 0 }).animate({ opacity: 1 }, 300);
      }
    }
  }
});